import Add from '@mui/icons-material/Add';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function AddIcon(props: FixMe) {
  return <Add {...props} />;
}

export default AddIcon;
